var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0593 0H11.8922C11.639 0 11.4336 0.204752 11.4336 0.457845V8.70856C11.4336 8.96165 11.639 9.16641 11.8922 9.16641H13.2672V11L16.9343 9.16641H21.0593C21.3124 9.16641 21.5172 8.96161 21.5172 8.70856V0.457845C21.5172 0.204709 21.3124 0 21.0593 0Z",
    fill: "#FFCE54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5426 18.6672H2.20902C2.20902 18.6672 -0.224075 7.33423 6.87582 7.33423C13.9751 7.33419 11.5426 18.6672 11.5426 18.6672Z",
    fill: "#E2A437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1135 18.4005L12.0619 18.3857C11.3038 18.1823 11.0474 17.9863 10.7097 17.858C9.51257 17.4022 9.20108 17.0732 9.12116 16.9181C9.11849 16.9121 9.11647 16.906 9.11376 16.9007L9.10371 15.5102L6.87537 15.478L4.64703 15.5102L4.63698 16.9007C4.63431 16.906 4.63229 16.9121 4.62959 16.9181C4.54971 17.0732 4.23817 17.4022 3.04107 17.858C2.70337 17.9863 2.44688 18.1823 1.68889 18.3857L1.63651 18.4005C0.946326 18.6288 0.482422 19.2686 0.482422 19.9911V21.9998H6.87537H13.2683V19.9911C13.2683 19.2686 12.8038 18.6288 12.1135 18.4005Z",
    fill: "#A0D468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8156 12.8058C10.8156 15.3658 8.37516 17.7217 6.87594 17.7217C5.37607 17.7217 2.93555 15.3658 2.93555 12.8058C2.93555 10.2458 4.69998 8.55664 6.87594 8.55664C9.0519 8.55664 10.8156 10.2458 10.8156 12.8058Z",
    fill: "#EAC6BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59481 10.2218L4.04785 12.5776L2.74805 12.8891L3.05485 11.2214L3.92633 8.9172L6.37085 8.03906L9.23566 8.22972L10.4388 10.2922L10.7832 11.8142L7.59481 10.2218Z",
    fill: "#FFCE54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9108 13.509C11.7799 11.4412 11.2212 9.28199 9.64618 8.146L7.85291 9.64187L7.33594 10.3992L11.9041 13.5185L11.9108 13.509Z",
    fill: "#F6BB42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7105 5.18579L17.8515 5.04816L18.9452 3.98268L17.4339 3.76314L17.2392 3.73427L17.1519 3.5577L16.4765 2.18872L15.8005 3.5577L15.7139 3.73427L15.5185 3.76314L14.0078 3.98268L15.1009 5.04816L15.2419 5.18579L15.209 5.37984L14.9505 6.88444L16.302 6.17406L16.4765 6.0821L16.6504 6.17406L18.0019 6.88444L17.7441 5.37984L17.7105 5.18579Z",
    fill: "#ED5564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82812 13.6721C3.61001 13.3472 5.57915 12.3803 7.68193 10.7965C8.93541 9.85193 9.85187 8.97302 10.1996 8.62664C9.43828 7.83504 8.36743 7.33423 6.87426 7.33423C3.04336 7.33419 1.98793 10.6334 1.82812 13.6721Z",
    fill: "#FFCE54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.4c60b7bbc2abdf10ddb18c2a5f7f50e2.svg";
export { ForwardRef as ReactComponent };